import { ReduxAction } from '../types';
import { NotificationsActionPayload, NotificationsState } from './types';

export const INCREMENT_STREAM_ACTIVITIES = 'INCREMENT_STREAM_ACTIVITIES';
export const DECREMENT_STREAM_ACTIVITIES = 'DECREMENT_STREAM_ACTIVITIES';
export const RESET_STREAM_ACTIVITIES = 'RESET_STREAM_ACTIVITIES';

export const INCREMENT_STREAM_NOTIFICATIONS = 'INCREMENT_STREAM_NOTIFICATIONS';
export const DECREMENT_STREAM_NOTIFICATIONS = 'DECREMENT_STREAM_NOTIFICATIONS';
export const RESET_STREAM_NOTIFICATIONS = 'RESET_STREAM_NOTIFICATIONS';

// action type to reset all stream alerts
export const RESET_STREAM_ALERTS = 'RESET_STREAM_ALERTS';

export const incrementStreamActivities: ReduxAction<
  NotificationsState,
  NotificationsActionPayload
> = () => ({
  type: INCREMENT_STREAM_ACTIVITIES,
});

export const decrementStreamActivities: ReduxAction<
  NotificationsState,
  NotificationsActionPayload
> = () => ({
  type: DECREMENT_STREAM_ACTIVITIES,
});

export const resetStreamActivities: ReduxAction<
  NotificationsState,
  NotificationsActionPayload
> = () => ({
  type: RESET_STREAM_ACTIVITIES,
});

export const incrementStreamNotifications: ReduxAction<
  NotificationsState,
  NotificationsActionPayload
> = () => ({
  type: INCREMENT_STREAM_NOTIFICATIONS,
});

export const decrementStreamNotifications: ReduxAction<
  NotificationsState,
  NotificationsActionPayload
> = () => ({
  type: DECREMENT_STREAM_NOTIFICATIONS,
});

export const resetStreamNotifications: ReduxAction<
  NotificationsState,
  NotificationsActionPayload
> = () => ({
  type: RESET_STREAM_NOTIFICATIONS,
});

export const resetStreamAlerts: ReduxAction<
  NotificationsState,
  NotificationsActionPayload
> = () => ({
  type: RESET_STREAM_ALERTS,
});
